var map = {
	"./en/about.json": [
		2019,
		[
			19
		]
	],
	"./en/footer.json": [
		1521,
		[
			521
		]
	],
	"./en/home.json": [
		3289,
		[
			289
		]
	],
	"./en/navigation.json": [
		2240,
		[
			240
		]
	],
	"./en/navigator.json": [
		2819,
		[
			819
		]
	],
	"./en/next_steps.json": [
		9707,
		[
			707
		]
	],
	"./en/procedure_lumpectomy.json": [
		857,
		[
			857
		]
	],
	"./en/procedure_mastectomy.json": [
		3418,
		[
			418
		]
	],
	"./en/procedure_other.json": [
		474,
		[
			474
		]
	],
	"./en/resources.json": [
		1867,
		[
			867
		]
	],
	"./en/sidenav.json": [
		8914,
		[
			914
		]
	],
	"./en/summary.json": [
		1282,
		[
			282
		]
	],
	"./en/to_consyder.json": [
		3903,
		[
			903
		]
	],
	"./en/treatment_options.json": [
		9323,
		[
			323
		]
	],
	"./en/treatment_table.json": [
		4973,
		[
			973
		]
	],
	"./en/whats_important.json": [
		5936,
		[
			936
		]
	],
	"./es/about.json": [
		2820,
		[
			820
		]
	],
	"./es/footer.json": [
		4588,
		[
			588
		]
	],
	"./es/home.json": [
		5140,
		[
			140
		]
	],
	"./es/navigation.json": [
		3045,
		[
			45
		]
	],
	"./es/navigator.json": [
		7224,
		[
			224
		]
	],
	"./es/next_steps.json": [
		1346,
		[
			346
		]
	],
	"./es/procedure_lumpectomy.json": [
		8680,
		[
			680
		]
	],
	"./es/procedure_mastectomy.json": [
		5467,
		[
			467
		]
	],
	"./es/procedure_other.json": [
		5077,
		[
			77
		]
	],
	"./es/resources.json": [
		6528,
		[
			528
		]
	],
	"./es/sidenav.json": [
		5773,
		[
			773
		]
	],
	"./es/summary.json": [
		4093,
		[
			93
		]
	],
	"./es/to_consyder.json": [
		3716,
		[
			716
		]
	],
	"./es/treatment_options.json": [
		1452,
		[
			452
		]
	],
	"./es/treatment_table.json": [
		8754,
		[
			754
		]
	],
	"./es/whats_important.json": [
		6367,
		[
			367
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9512;
module.exports = webpackAsyncContext;